export default __webpack_public_path__ + "static/media/chevron-right-circle.25878d42.svg";